import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import i18n from 'src/utils/translate';
import { titleMedium } from 'styles-js/mixins/typography';
import api from 'src/utils/api';
import log from 'loglevel';
import { trackFootfallEvent } from 'src/utils/footfall';
import footfallEventTypes from 'src/constants/footfallEventTypes';

const Cta = styled.button`
  ${titleMedium};
  position: relative;
  top: 50px;
  width: 100%;
  padding: 20px 0;
  text-align: center;
  background-color: ${props => props.theme.colorButtonPrimary};
  color: ${props => props.theme.colorWhite};
  transition: all 0.5s ease;
  border: 0;
  &:hover {
    background-color: ${props => props.theme.colorButtonPrimaryHover};
    color: ${props => props.theme.colorWhite};
  }
`;

const ESocialPrescriptionCta = () => {
  const { currentUser, currentCommunity } = useSelector(state => state.context);

  if (!currentUser || !currentCommunity) return null;

  const eSPCommunities = [{slug: 'aonn', badges: ['Social Prescription', 'HealthUnlocked']}];
  const isESPCommunity = (c) => c.slug === currentCommunity.slug;
  const userHasBadge = (c) => c.badges.some((badge) => currentUser?.roles.includes(badge));
  const showESocialPrescriptionCta = currentUser && eSPCommunities.some(c => isESPCommunity(c) && userHasBadge(c));

  if (!showESocialPrescriptionCta) return null;

  const url = `private/${currentCommunity.slug}/token?app=${currentCommunity.slug}`;

  const handleClick = async () => {
    trackFootfallEvent(footfallEventTypes.CLICKED, { clickType: 'aonn-launch' });
    try {
      const { data } = await api.get(url);
      const newTab = window.open('', '_blank');
      newTab.location.href = `${data.url}?token=${data.token}`;
    } catch (error) {
      log.error(error);
      // TODO: try using router.replace() instead
      window.location.reload();
    }
  };

  return (
    <Cta className="e-social-prescription-cta" onClick={handleClick}>
      {i18n.t('Launch eSocial Prescription')} <span className="icon icon-link-ext"/>
    </Cta>
  );
};


export default ESocialPrescriptionCta;
